import { motion } from "framer-motion";

const benefits = [
  ["01", "See what is shaping you", "Bring the beliefs, patterns, and stories beneath your current experience into compassionate awareness."],
  ["02", "Understand your readiness", "Notice the strengths already supporting change and the areas that may need more care or reinforcement."],
  ["03", "Find a grounded next step", "Receive a clearer starting point for meaningful, whole-person transformation—without shame or pressure."],
];

export const ReadinessBenefits = () => (
  <section className="bg-[#f7f3ea] py-24 md:py-32" data-testid="readiness-benefits-section">
    <div className="readiness-shell">
      <div className="grid gap-10 border-b border-[#173f42]/15 pb-14 lg:grid-cols-12">
        <p className="readiness-kicker lg:col-span-4" data-testid="readiness-benefits-eyebrow">What you’ll discover</p>
        <h2 className="max-w-3xl font-serif text-5xl leading-none text-[#173f42] md:text-6xl lg:col-span-8" data-testid="readiness-benefits-title">Clarity before the next step.</h2>
      </div>
      <div className="grid gap-px bg-[#173f42]/15 md:grid-cols-3" data-testid="readiness-benefits-grid">
        {benefits.map(([number, title, copy], index) => (
          <motion.article key={title} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.5, delay: index * 0.08 }} className="bg-[#f7f3ea] px-1 py-12 md:px-8 lg:px-10" data-testid={`readiness-benefit-${index + 1}`}>
            <span className="font-serif text-3xl text-[#a06f3e]" data-testid={`readiness-benefit-${index + 1}-number`}>{number}</span>
            <h3 className="mt-10 font-serif text-3xl leading-tight text-[#173f42]" data-testid={`readiness-benefit-${index + 1}-title`}>{title}</h3>
            <p className="mt-5 text-sm leading-7 text-[#56645e]" data-testid={`readiness-benefit-${index + 1}-copy`}>{copy}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);